import { render, staticRenderFns } from "./PdfScore.vue?vue&type=template&id=1d8f2d6d&scoped=true&"
import script from "./PdfScore.vue?vue&type=script&lang=js&"
export * from "./PdfScore.vue?vue&type=script&lang=js&"
import style0 from "./PdfScore.vue?vue&type=style&index=0&id=1d8f2d6d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8f2d6d",
  null
  
)

export default component.exports